__turbopack_context__.v({
  "backgroundImage": "z8KyUW_backgroundImage",
  "body": "z8KyUW_body",
  "container": "z8KyUW_container",
  "description": "z8KyUW_description",
  "icon": "z8KyUW_icon",
  "iconContainer": "z8KyUW_iconContainer",
  "item": "z8KyUW_item",
  "list": "z8KyUW_list",
  "title": "z8KyUW_title",
});
